/**
 * India's states and union territories, as the API lists them (ACCT-07): GST is CGST + SGST
 * within one state and IGST across states, so the pharmacy and every delivery address must use the
 * same codes — free text let "TG" and "TS" (both Telangana) differ. A stored code the list doesn't
 * have (an older one) stays visible; saving it lets the API read it, or say to choose another.
 * The list is long, so its search box finds a state by name or code ("tn", "tamil").
 */

import { useQuery } from "@tanstack/react-query";

import { listStates } from "../../api/catalogue";
import { Select } from "./Select";

export function StateSelect({
  value,
  onChange,
  name,
  onBlur,
  invalid,
  className = "",
}: {
  value: string;
  onChange: (code: string) => void;
  name?: string;
  onBlur?: () => void;
  invalid?: boolean;
  /** Layout, size and error tweaks on top of the themed `.select-sm`. */
  className?: string;
}) {
  const { data: states = [], isError } = useQuery({
    queryKey: ["states"],
    queryFn: listStates,
    staleTime: Infinity,
    gcTime: Infinity,
  });
  const listed = states.some((s) => s.code === value);
  const options = [
    ...(value && !listed ? [{ value, label: value }] : []),
    ...states.map((s) => ({ value: s.code, label: s.name, keywords: s.code })),
  ];
  return (
    <Select
      name={name}
      value={value}
      options={options}
      onChange={onChange}
      onBlur={onBlur}
      required
      invalid={invalid}
      placeholder={isError ? "Couldn't load the states — reload the page" : "Select a state"}
      searchable
      className={className}
    />
  );
}
